import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { PhotoModerationGrid } from '../../features/photo-moderation/components/photo-moderation-grid';
import { listPhotoModerationOptions } from '../../features/photo-moderation/queries';
import { PageHeader } from '../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/photo-moderation')({
  staticData: { breadcrumb: 'Модерация фото' },
  loader: ({ context }) => context.queryClient.ensureQueryData(listPhotoModerationOptions()),
  component: PhotoModerationPage,
});

function PhotoModerationPage() {
  const { data } = useSuspenseQuery(listPhotoModerationOptions());
  return (
    <div>
      <PageHeader
        title="Модерация фото"
        description="Фото знакомств, ожидающие проверки перед показом в подборе."
      />
      <PhotoModerationGrid items={data.items} />
    </div>
  );
}
